import React from 'react';
import styled from 'styled-components';

import MUIExpansionPanel from '@material-ui/core/ExpansionPanel';
import MUIExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import MUIExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MUIExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';

const border = props => `1px solid ${props.theme.colors.inactiveColor}`;

const ExpansionPanel = styled(props => <MUIExpansionPanel {...props} />)`
  &.MuiPaper-elevation0 {
    border-left: ${border};
    border-right: ${border};
    border-bottom: ${border};
  }

  &.MuiPaper-elevation0:first-child {
    border-top: ${border};
  }

  &.MuiPaper-elevation0.MuiExpansionPanel-root.Mui-expanded + .MuiExpansionPanel-root:before {
    display: block;
  }

  &.MuiExpansionPanel-root.Mui-expanded:before {
    opacity: 1;
  }


  &.MuiExpansionPanel-rounded:first-child {
    border-top-left-radius: ${props => props.theme.borderRadius.medium};
    border-top-right-radius: ${props => props.theme.borderRadius.medium};
  }
  &.MuiExpansionPanel-rounded:last-child {
    border-bottom-left-radius: ${props => props.theme.borderRadius.medium};
    border-bottom-right-radius: ${props => props.theme.borderRadius.medium};
  }

  ${props => props.expansionPanelStyles};
`;

ExpansionPanel.Details = styled(props => <MUIExpansionPanelDetails {...props} />)``;
ExpansionPanel.Summary = styled(props => <MUIExpansionPanelSummary {...props} />)``;
ExpansionPanel.Actions = styled(props => <MUIExpansionPanelActions {...props} />)``;

export default ExpansionPanel;
